var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 95,
    viewBox: "0 0 123 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 93.9437H112.648C118.171 93.9437 122.648 89.4665 122.648 83.9437V16.7485C122.648 11.2257 118.171 6.74851 112.648 6.74851H62.1456C59.7584 6.74851 57.5578 5.45779 56.3927 3.37425C55.2276 1.29072 53.027 0 50.6398 0H9.99976C4.47691 0 -0.000244141 4.47716 -0.000244141 10V83.9437C-0.000244141 89.4665 4.47691 93.9437 9.99976 93.9437Z",
    fill: "#214C7B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.21875,
    y: 10.1482,
    width: 109.601,
    height: 79.1562,
    rx: 10,
    fill: "black",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.504 94.0886H10C4.47715 94.0886 0 89.6115 0 84.0886V35.0806C0 29.5578 4.47715 25.0806 10 25.0806H59.8402C62.6806 25.0806 65.253 23.4031 66.3985 20.8039C67.5439 18.2046 70.1163 16.5271 72.9567 16.5271H112.504C118.027 16.5271 122.504 21.0043 122.504 26.5271V84.0886C122.504 89.6115 118.027 94.0886 112.504 94.0886Z",
    fill: "#2D6CB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankEmpty);
export default __webpack_public_path__ + "static/media/blankEmpty.4ef47771c4d063b53ecd4af089ba8c02.svg";
export { ForwardRef as ReactComponent };